<template>
  <span :class="$style.awSpinner">
    <div :class="$style.vMoon1" :style="spinnerStyle">
      <div
        :class="$style.vMoon2"
        :style="[spinnerMoonStyle, animationStyle2]"
      />
      <div
        :class="$style.vMoon3"
        :style="[spinnerStyle, animationStyle3]"
      />
    </div>
  </span>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    color: {
      type: String,
      default: '#433F32',
    },
    widthWithUnit: {
      type: String,
      default: '2rem',
    },
    heightWithUnit: {
      type: String,
      default: '2rem',
    },
    styling: {
      type: Object,
      default: () => ({}),
    },
  });

  const spinnerStyle = computed(() => {
    return {
      ...props.styling,
      height: props.heightWithUnit,
      width: props.widthWithUnit,
      borderRadius: '100%',
    };
  });

  const moonSize = computed(() => {
    return 'calc(' + props.heightWithUnit + ' / 3.5)';
  });

  const spinnerMoonStyle = computed(() => {
    return {
      height: moonSize.value,
      width: moonSize.value,
      borderRadius: '100%',
    };
  });

  const animationStyle2 = computed(() => {
    return {
      ...props.styling,
      top: 'calc(calc(' + props.widthWithUnit + ' / 2) - calc(' + moonSize.value + ' / 2))',
      backgroundColor: props.color,
    };
  });

  const animationStyle3 = computed(() => {
    return {
      border: moonSize.value + ' solid ' + props.color,
    };
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.awSpinner {
  display: flex;
  justify-content: center;
}

%vMoonBase {
  animation: vMoonStretchDelay 0.6s 0s infinite linear;
  animation-fill-mode: forwards;
}

.vMoon1 {
  @extend %vMoonBase;
  position: relative;
}

.vMoon2 {
  @extend %vMoonBase;
  position: absolute;
  opacity: 1;
  background-color: $color-text-primary;
}

.vMoon3 {
  opacity: 0.1;
}

@keyframes vMoonStretchDelay {
  100% {
    transform: rotate(360deg);
  }
}
</style>
